@if (showTag) {
  <div class="multiple-tags">
    <div class="selected-label">
      <div class="tag">
        <img src="assets/images/arrows/tag-arrow.svg" />
        <div>{{ displayText }}</div>
      </div>
    </div>
  </div>
}
